(() => {
  const syncDiameterSelection = (picker) => {
    picker.querySelectorAll('input[name="Stangendurchmesser der Growbox"]').forEach((input) => {
      input.nextElementSibling?.classList.toggle('growber-diameter-selected', input.checked);
    });
  };

  const arrangeProductOptions = (root = document) => {
    root.querySelectorAll('product-info').forEach((productInfo) => {
      const picker = productInfo.querySelector('variant-radios');
      const quantity = productInfo.querySelector('.product-form__quantity');
      const colorFieldset = picker
        ?.querySelector('input[name="Farbe"]')
        ?.closest('fieldset');

      if (!picker || !quantity || !colorFieldset) return;

      const syncDiameterLabels = () => {
        picker.querySelectorAll('input[name="Stangendurchmesser der Growbox"]').forEach((input) => {
          const label = input.nextElementSibling;
          if (!label) return;

          if (!label.querySelector('.growber-diameter-check')) {
            const check = document.createElement('span');
            check.className = 'growber-diameter-check';
            check.setAttribute('aria-hidden', 'true');
            label.prepend(check);
          }

          if (!label.querySelector('.growber-diameter-copy')) {
            const textNodes = Array.from(label.childNodes).filter(
              (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
            );
            const text = textNodes
              .map((node) => node.textContent.trim())
              .join(' ')
              .replace(/\s+/g, ' ');

            if (text) {
              const copy = document.createElement('span');
              copy.className = 'growber-diameter-copy';
              const lines = text.match(/^(.*?mm)\s+(.+)$/i);

              if (lines) {
                const firstLine = document.createElement('span');
                firstLine.className = 'growber-diameter-copy-line';
                const diameterParts = lines[1].match(/^(.*?)([∅Øø]\s*\d+\s*mm)$/i);

                if (diameterParts) {
                  const diameter = document.createElement('span');
                  diameter.className = 'growber-diameter-value';
                  diameter.textContent = diameterParts[2];
                  firstLine.append(diameterParts[1], diameter);
                } else {
                  firstLine.textContent = lines[1];
                }

                const secondLine = document.createElement('span');
                secondLine.className = 'growber-diameter-copy-line';
                secondLine.textContent = lines[2];
                copy.append(firstLine, secondLine);
              } else {
                copy.textContent = text;
              }

              textNodes.forEach((node) => node.remove());
              label.append(copy);
            }
          }
        });
      };

      syncDiameterLabels();
      syncDiameterSelection(picker);
      if (picker.dataset.growberDiameterSyncReady !== 'true') {
        picker.dataset.growberDiameterSyncReady = 'true';
        picker.addEventListener('change', () => syncDiameterSelection(picker));
      }
      if (colorFieldset.closest('.growber-product-options-row')) return;

      const row = document.createElement('div');
      row.className = 'growber-product-options-row';
      colorFieldset.before(row);
      row.append(colorFieldset, quantity);

      // Quantity changes must not trigger Dawn's variant picker handler.
      quantity.addEventListener('change', (event) => event.stopPropagation());

    });
  };

  const initProductOptionsLayout = () => arrangeProductOptions();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductOptionsLayout, {
      once: true,
    });
  } else {
    initProductOptionsLayout();
  }

  document.addEventListener('shopify:section:load', (event) => {
    arrangeProductOptions(event.target);
  });

  const marker = new URLSearchParams(window.location.search).get(
    'finder_variant'
  );
  const requestedId = new URLSearchParams(window.location.search).get('variant');

  if (!/^\d+$/.test(requestedId || '')) return;

  const preserveFinderState = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', requestedId);
    url.searchParams.set('finder_variant', '1');
    window.history.replaceState(window.history.state, '', url);
  };

  const applyVariant = () => {
    const pickers = document.querySelectorAll('variant-radios, variant-selects');

    for (const picker of pickers) {
      const dataElement = picker.querySelector(
        'script[type="application/json"]'
      );
      if (!dataElement) continue;

      let variants;
      try {
        variants = JSON.parse(dataElement.textContent || '[]');
      } catch (_) {
        continue;
      }

      const variant = variants.find(
        (item) => String(item.id) === String(requestedId)
      );
      if (!variant) continue;

      const values = (
        variant.options || [variant.option1, variant.option2, variant.option3]
      ).filter(Boolean);

      if (picker.matches('variant-radios')) {
        const fieldsets = picker.querySelectorAll('fieldset');
        const inputs = values.map((value, index) =>
          Array.from(
            fieldsets[index]?.querySelectorAll('input[type="radio"]') || []
          ).find((input) => input.value === value)
        );

        if (inputs.length !== values.length || inputs.some((input) => !input)) {
          continue;
        }

        inputs.forEach((input) => {
          input.checked = true;
        });
        inputs.at(-1).dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const selects = picker.querySelectorAll('select');
        if (selects.length < values.length) continue;

        values.forEach((value, index) => {
          selects[index].value = value;
        });
        selects[values.length - 1].dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }

      picker.dataset.growberFinderVariant = requestedId;
      syncDiameterSelection(picker);

      if (marker === '1') window.setTimeout(preserveFinderState, 0);
      return true;
    }

    return false;
  };

  const init = () => {
    if (applyVariant()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (applyVariant() || attempts >= 20) window.clearInterval(timer);
    }, 150);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
